/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
// 格式化日期
export function filterDate(date, sign = '-') {
  if (date instanceof Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return year + sign + (month < 10 ? `0${month}` : month) + sign + (day < 10 ? `0${day}` : day);
  }
  return new Error('filterDate传参错误');
}

/**
 * 格式化date
 * @param validDate 任何可以new Date()的有效日期
 * @param fmt 形如 "yyyy-MM-dd hh:mm:ss", "MM月-dd日" 等字符串
 */
export function formatDatetime(validDate, fmt) {
  if (typeof validDate === 'string') {
    validDate = validDate.replace('T', ' ').replace(/-/g, '/');
  } else if (validDate === undefined || validDate === null) {
    return '';
  }
  const date = new Date(validDate);
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length),
      );
    }
  }
  return fmt;
}

function stringifyDate(datetime, type) {
  // let weekMap = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  datetime = new Date(datetime);
  const year = datetime.getFullYear();
  const simpleYear = datetime.getYear() - 100;
  let month = datetime.getMonth() + 1;
  month = month > 9 ? month : `0${month}`;
  let day = datetime.getDate();
  day = day > 9 ? day : `0${day}`;
  let hour = datetime.getHours();
  hour = hour > 9 ? hour : `0${hour}`;
  let min = datetime.getMinutes();
  min = min > 9 ? min : `0${min}`;
  let week = datetime.getDay();
  week = weekMap[week];
  const thatDay = new Date(year, month - 1, day, 0, 0, 0).getTime();

  if (type === 1) {
    return {
      withYear: `${year}-${month}-${day} ${hour}:${min}`,
      withMonth: `${month}-${day} ${hour}:${min}`,
      withDay: `${week} ${hour}:${min}`,
      withLastDay: `昨天 ${hour}:${min}`,
      withHour: `${hour}:${min}`,
      thatDay,
    };
  }
  if (type === 2) {
    return {
      withYear: `${day}/${month}/${simpleYear}`,
      withMonth: `${month}-${day}`,
      withDay: `${week}`,
      withLastDay: '昨天',
      withHour: `${hour}:${min}`,
      thatDay,
    };
  }
  return {
    withYear: `${year}年${month}月${day}日`,
    withMonth: `${month}月${day}日`,
    withDay: `${month}月${day}日`,
    withLastDay: '昨天',
    withHour: `${hour}:${min}`,
    thatDay,
  };
}

/* 格式化日期 */
export function formatGoodDate(datetime, type) {
  const tempDate = new Date().getTime();
  const result = stringifyDate(datetime, type);
  const { thatDay } = result;
  const deltaTime = (tempDate - thatDay) / 1000;

  if (deltaTime < 3600 * 24) {
    return result.withHour;
  }
  if (deltaTime < 3600 * 24 * 2) {
    return result.withLastDay;
  }
  if (deltaTime < 3600 * 24 * 7) {
    return result.withDay;
  }
  if (deltaTime < 3600 * 24 * 30) {
    return result.withMonth;
  }
  return result.withYear;
}

export function getWeek(validDate) {
  if (typeof validDate === 'string') {
    validDate = validDate.replace('T', ' ').replace(/-/g, '/');
  } else if (validDate === undefined) {
    return '';
  }
  const date = new Date(validDate);

  const arr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  return arr[date.getDay()];
}

// 获取当天延后 "num"天的日期
export function getDelayDay(day = 0, hour = 0) {
  let today = new Date();
  today = new Date(formatDatetime(today, 'yyyy/MM/dd'));
  return today.getTime() + day * 24 * 60 * 60 * 1000 + hour * 60 * 60 * 1000;
}

/**
 * 获取以当前时间为基准，指定向前/或向后指定多少个时间单位
 * 示例：
 * app.tool.date.getBasedOnToDayDate(-7) // 获取七天前的此时
 * app.tool.date.getBasedOnToDayDate(7) // 获取七天后的此时
 * app.tool.date.getBasedOnToDayDate(-1, 'Month') // 获取一个月前的此时
 *
 * @param { Number } vals 具体多少个时间单位，几天/或几小时前用负数
 * @param { String } type 指定日期单位，默认Date(天)，可能值：Month(月)、Year(年)、Hours、Minutes、Seconds等
 * @param { Object Date } today 基准时间，默认当前时间
 * @returns Date
 */
export function getBasedOnToDayDate(vals, type = 'Date', today = new Date()) {
  if (!today[`set${type}`]) type = 'Date';
  today[`set${type}`](today[`get${type}`]() + vals);

  return new Date(today);
}

function toFixedFix(n, prec) {
  const k = 10 ** prec;
  return `${(Math.round(n * k) / k).toFixed(prec)}`;
}

/**
 * 格式化数字
 * @param number 必需，要格式化的数字
 * @param decimals 可选，规定多少个小数位，默认两位。
 * @param point 可选，规定用作小数点的字符串（默认为 . ）。
 * @param thousands 可选，规定用作千位分隔符的字符串（默认为 , ），如果设置了该参数，那么所有其他参数都是必需的。
 */
export function formatNumber(number, decimals, point, thousands) {
  // https://github.com/txgruppi/number_format
  // form http://phpjs.org/functions/number_format/
  number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
  const n = !Number.isFinite(+number) ? 0 : +number;
  const prec = !Number.isFinite(+decimals) ? 2 : Math.abs(decimals);
  const sep = typeof thousands === 'string' ? thousands : ',';
  const dec = point || '.';
  let s = '';

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  return s.join(dec);
}

/**
 * 在formatNumber的基础上,百万级别用万为单位.
 */
export function formatNumberUnit(...args) {
  const unit = '万';
  if (parseFloat(args[0]) > 1000000) {
    args[0] /= 10000;
    return formatNumber(...args) + unit;
  }
  return formatNumber(...args);
}

// 物品商品名称格式化
export function getGoodsShowName(name, type, priceName) {
  let str = name;
  // 按物品定价
  if (type === 2) {
    str += `(${priceName})`;
  }
  return str;
}

// 通过时间段获取分钟数
export function getMinutes(timeObj) {
  const { startTime, endTime } = timeObj;
  return `${(new Date(`2020/01/01 ${endTime}:00`) - new Date(`2020/01/01 ${startTime}:00`))
    / 1000
    / 60}分钟`;
}
